// extracted by mini-css-extract-plugin
export default {"isTopShadow":"TylwMQJRELgU03MlTEcs","isBottomShadow":"RneXOf6vXoJ_9yBlFzbE","placeHolderShimmer":"vLNKhKxQQn23K3ksnqmw"};